import { Controller } from "stimulus";
import { copyToClipboard } from "../helpers/clipboard_helpers";

export default class extends Controller {
  async ldpCopyLinkToClipboard(event) {
    const textToCopy = $("#ldp_share_link").val();
    if ($("#ldp_share_link_button").attr("disabled") || textToCopy === "" || !textToCopy.startsWith("https://")) {
      event.stopPropagation();
      return;
    }

    await copyToClipboard(textToCopy);
  }

}
